import { inject, Injectable } from '@angular/core';
import { Response } from '../../../../_shared/models';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { HttpClient } from '@angular/common/http';
import { Subject, takeUntil } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { MakeAndModel } from '../../models/make-model.model';

@Injectable({ providedIn: 'root' })
export class MakeModelFilterService {
  private http = inject(HttpClient)

  public getMakeModelList(accountIds: number[], cancellation: Subject<void>): Promise<Response<MakeAndModel[]>> {
    return firstValueFrom(this.http.post<Response<Array<MakeAndModel>>>(`${environment.apiEndpoint}/accounts/make-model`, { accountIds })
      .pipe(takeUntil(cancellation)));
  }
}